module.exports = __webpack_public_path__ + "img/txt_series_114.dd75ba2f.png";